import { render, staticRenderFns } from "./GenericOTList.vue?vue&type=template&id=60a5b870&scoped=true&lang=pug"
import script from "./GenericOTList.vue?vue&type=script&lang=js"
export * from "./GenericOTList.vue?vue&type=script&lang=js"
import style0 from "./GenericOTList.vue?vue&type=style&index=0&id=60a5b870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5b870",
  null
  
)

export default component.exports